module.exports = __webpack_public_path__ + "static/img/边框1.5d8b434.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框1.svg
// module id = eyU+
// module chunks = 2